import React from "react";
import { useNavigate } from "react-router-dom";

function About(){
  const navigate=useNavigate()
  function handleClick(){
    alert("By clicking you accept our Agreement are you sure you want to continue?")
    navigate("/login")
  }
    return(
        <div className="about">
            <h1>Hello and Welcome To Valetroni</h1>
            <h2>About Us</h2>
    <p>Valetroni Car Dealership has been serving customers since 1990, providing top-quality vehicles and exceptional customer service. We pride ourselves on offering a wide selection of vehicles from various makes and models to meet the diverse needs and preferences of our valued customers.</p>
    
    <h2>Our Mission</h2>
    <p>At Valetroni Car Dealership, our mission is to deliver a seamless and enjoyable car buying experience. We strive to exceed our customers' expectations by providing transparent pricing, reliable vehicles, and personalized assistance throughout the entire process.</p>
    
    <h2>Why Choose Valetroni Car Dealership?</h2>
    <ul>
      <li>Extensive inventory of new and pre-owned vehicles</li>
      <li>Competitive pricing and flexible financing options</li>
      <li>Knowledgeable and friendly sales team</li>
      <li>Thorough vehicle inspections and history reports</li>
      <li>Convenient location with ample parking</li>
      <li>Exceptional after-sales service and maintenance</li>
    </ul>
    
    <h2>Contact Information</h2>
    <p>If you have any questions or inquiries, please feel free to get in touch with us. Our dedicated team is here to assist you.</p>
    <ul>
      <li><strong>Address:</strong> 123 Main Street, Cityville, State, ZIP</li>
      <li><strong>Phone:</strong>+254773470576 or +254114809906 or +254789255754</li>
      <li><strong>Email:</strong>Valetroni2244@gmail.com</li>
    </ul>
    <footer>
    <p>&copy; 2023 Valetroni Car Dealership. All rights reserved.</p>
    </footer> 
    <div className="container">
    <input type="checkbox" id="cbx"/>
    <label htmlFor="cbx" className="check">
        <svg width="40px" height="40px" viewBox="0 0 18 18">
            <path d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z"></path>
            <polyline points="1 9 7 14 15 4"></polyline>
        </svg>
    </label>
    </div>
    <button className="btn" onClick={handleClick}>Agree</button>

        </div>
    )
}
export default About;